import Select from "react-select";
import { GetProductMasterData } from "../store/productAtom";

function PlanPlatformSelect(props) {
  const masterData = GetProductMasterData();
  const customOption = masterData[10]?.map((item) => {
    return { ...item, label: `${item.Name}` };
  });

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#f9fafb", // Tailwind: bg-gray-50
      borderColor: state.isFocused ? "#0000FF" : "#d1d5db", // gray-400 or gray-300
      boxShadow: state.isFocused ? "0 0 0 1px #9ca3af" : "none", // subtle gray ring
      // "&:hover": {
      //   borderColor: "#9ca3af", // gray-400
      // },
      height: 42,
      // border: 4,
      borderRadius: 6, // rounded-md
      paddingLeft: 4,
      paddingRight: 4,
      fontSize: 14,
      width: "100%",
      transition: "all 0.2s ease-in-out",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af", // gray-400
    }),
    singleValue: (base) => ({
      ...base,
      color: "#111827", // gray-900
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#6b7280" : "#9ca3af", // gray-500/gray-400
      "&:hover": {
        color: "#6b7280", // gray-500
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#ffffff", // white dropdown
      borderRadius: 6,
      boxShadow: "0 4px 14px rgba(0, 0, 0, 0.05)",
      marginTop: 4,
      fontSize: 14,
      boxShadow: "0 0 0 1px #d1d5db",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#FFFFFF" // gray-200
        : state.isFocused
        ? "#f3f4f6" // gray-100
        : "#ffffff", // white
      color: "#111827", // gray-900
      padding: "8px 12px",
      cursor: "pointer",
      borderColor: state.isFocused ? "#9ca3af" : "#d1d5db", // gray-400 or gray-300
      "&:hover": {
        backgroundColor: "#f3f4f6", // gray-400
      },
      border: "2px",
      transition: "background-color 0.2s ease",
    }),
  };

  const handleChange = (value) => {
    props.onPlatformSelect(value);
  };

  return (
    <>
      <Select
        styles={customStyles}
        defaultValue={props?.defaultVal}
        onChange={handleChange}
        options={customOption}
      />
    </>
  );
}

export default PlanPlatformSelect;
